// utils
import { isEmpty } from "@swiggy-private/core-ui";
// constants
import { PLACEHOLDERS } from "@super-ui/constants";

export const emojiToTextConverter = (emoji: string) => {
    try {
        if (isEmpty(emoji)) return "";
        return String.fromCodePoint(parseInt(emoji));
    } catch {
        return "";
    }
};

export const headerBuilder = (text = "", titleUnicode = "") => {
    if (isEmpty(text)) return null;

    return text.replace(PLACEHOLDERS.BS_HEADER_UNICODE, emojiToTextConverter(titleUnicode));
};
